import { GREnvironment } from '@shared/models';
import { SystemNumberStatusEnum } from '@shared/enums/system-number-status-enum';
import { CampaignTypeEnum } from '@shared/enums/campaign-type-enum';
import { MessageTypeEnum } from '@shared/enums';
import useAxios, { UseAxiosResult } from 'axios-hooks';

export interface IClientLocalSystemNumberRecord {
  id: string;
  phoneNumber: number;
  status: SystemNumberStatusEnum;
  grTcrCampaignId: string | null;
  tcrCampaignId: string | null;
  campaignType: CampaignTypeEnum | null;
  messageType: MessageTypeEnum | null;
  providerId: string | null;
  providerName: string | null;
  providerProfileId: string | null;
}

export interface IClientLocalSystemNumbersResponse {
  totalCount: number;
  records: IClientLocalSystemNumberRecord[];
}

export interface UseClientLocalSystemNumbersRequest {
  clientId?: string;
  environment?: GREnvironment;
  limit?: number;
}

const useClientLocalSystemNumbers = ({ clientId, environment, limit = 1000 }: UseClientLocalSystemNumbersRequest): UseAxiosResult<IClientLocalSystemNumbersResponse> => {
  return useAxios<IClientLocalSystemNumbersResponse>({
    url: `/clients/${clientId}/local-system-numbers`,
    method: 'GET',
    params: { offset: 0, limit, environment },
  }, {
    manual: !clientId || !environment,
  });
};

export default useClientLocalSystemNumbers;
